import React from "react";

export function LocalFlashAttentionToggleButton({
  enabled,
  onToggle,
  isBusy,
}) {
  return (
    <button
      type="button"
      className={[
        "ai-chat-flash-attention-toggle",
        enabled
          ? "ai-chat-flash-attention-toggle--enabled"
          : "ai-chat-flash-attention-toggle--disabled",
      ].join(" ")}
      onClick={() => {
        if (isBusy) return;
        onToggle?.();
      }}
      aria-pressed={enabled}
      title={
        enabled
          ? "Flash attention will be enabled by default when loading the local model."
          : "Flash attention will be disabled by default when loading the local model."
      }
    >
      Flash Attention
    </button>
  );
}

